import { Fragment } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import ButtomButton from "../../../../components/DocButtomButton";
import { addDocumentInstruction } from "../../../../actions/document.action";
import ErrorInputComponent from "../../../../components/ErrorInputComponent";
import { Loading } from "../../../../utils/helpers/constants";
import DropDownInput from "../../../../components/DropDownInput";
import { costTypes } from "../../../../utils/mapper/mappers";

export default function CreateInstructionModal({
  open,
  setOpen,
  cancelButtonRef,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    fee: { feeLoading },
  } = useSelector(({ feeReducer }) => ({
    fee: feeReducer,
  }));

  const validationSchema = Yup.object({
    description: Yup.string().required("Description is required"),
    costType: Yup.string().required("Cost type is required"),
  });
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      description: "",
      costType: "OTHERS",
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        description: values.description,
        costType: values.costType,
      };
      const reload = () => history.go(0);
      console.log("payload ", payload);
      const instructions = [payload];
      console.log("instructions ", instructions);
      const documentType = "TRANSCRIPT_OFFICIAL";
      dispatch(addDocumentInstruction(documentType, instructions, reload));
    },
  });

  const buttonLoadState = feeLoading === Loading.FETCHING;

  console.log("create instruction modal ...");
  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-cente justify-center min-h-full p-4 text-cente sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="">
                    <div className="">
                      <div className="mb-6 bg-gray-800 p-4 rounded-t-md">
                        <div className="flex text-xl items-center text-white">
                          <AiOutlineClose
                            onClick={() => setOpen(false)}
                            className="cursor-pointer"
                          />
                          <div className="ml-auto mr-auto font-bold">
                            Add Instruction
                          </div>
                        </div>
                      </div>
                      <div className="mt-10 sm:px-6 px-6 w-full">
                        <form>
                          <DropDownInput
                            placeholder="Cost Type"
                            name="costType"
                            handleChange={handleChange}
                            list={costTypes}
                          />
                          <ErrorInputComponent error={errors.feeType} />

                          <textarea
                            className="mb-2 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                            id="inline-full-name"
                            type="textarea"
                            name="description"
                            rows={5}
                            onChange={handleChange}
                            placeholder="Document Instruction"
                          />
                          <ErrorInputComponent error={errors.description} />
                        </form>
                      </div>
                      <ButtomButton
                        name={"Proceed"}
                        func={handleSubmit}
                        loading={buttonLoadState}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
